import * as http from 'utils/http';
import {
  updateCarrier as UpdateCarrierReducer,
  updateDocuments as updateDocumentsReducer,
  removeCarrier as RemoveCarrierReducer,
} from 'redux/modules/carrier-section/duck';

export const updateCarrier = (carrier) => {
  return (dispatch, getState, config) => {
    return http
      .patch(`${config.API_URL}carriers/${carrier.id}/`, carrier)
      .then((response) => {
        dispatch(UpdateCarrierReducer(response));
        return response;
      })
      .catch((err) => {
        throw err;
      });
  };
};

export const updateDocuments = (carrierId) => {
  return async (dispatch, getState, config) => {
    return http
      .get(`${config.BASE_URL}/api/dms/documents/carrier/${carrierId}/`)
      .then((response) => {
        dispatch(updateDocumentsReducer(response));
        return response;
      })
      .catch((err) => {
        throw err;
      });
  };
};

export const removeCarrier = (carrier) => {
  return (dispatch, getState, config) => {
    return http
      .post(`${config.API_URL}carriers/${carrier.id}/remove/`, carrier)
      .then((response) => {
        dispatch(RemoveCarrierReducer(response));
        return response;
      })
      .catch((err) => {
        throw err;
      });
  };
};
